import APIController from '../core-api-controller';

export const fetchPatientSubscriptionsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/client_user/subscriptions${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchPatientSubscriptionDetailApi = (id = '') => {
  const path = `${APIController.endpointApi}/client_user/subscriptions/${id}`;
  return APIController.getApiCallback(path);
};
